import { gql } from '@apollo/client';

export const CLOSE_ASSIGNMENT = gql`
  mutation CloseAssignment($input: CloseAssignmentInput!) {
    closeAssignment(input: $input) {
      id
      isAssigned
      updatedAt
    }
  }
`;

export const OPEN_ASSIGNMENT = gql`
  mutation OpenAssignment($input: OpenAssignmentInput!) {
    openAssignment(input: $input) {
      id
      isAssigned
      updatedAt
    }
  }
`;

export const DELETE_ASSIGNMENT = gql`
  mutation DeleteAssignment($input: DeleteAssignmentInput!) {
    deleteAssignment(input: $input)
  }
`;

export const STUDENT_START_ASSIGNMENT = gql`
  mutation StudentStartAssignment($input: StudentStartAssignmentInput!) {
    studentStartAssignment(input: $input)
  }
`;

export const STUDENT_SUBMIT_ASSIGNMENT = gql`
  mutation StudentSubmitAssignment($input: StudentSubmitAssignmentInput!) {
    studentSubmitAssignment(input: $input)
  }
`;

export const RESET_STUDENT_ASSIGNMENT_SUBMISSION = gql`
  mutation ResetStudentAssignmentSubmission(
    $input: ResetStudentAssignmentSubmissionInput!
  ) {
    resetStudentAssignmentSubmission(input: $input)
  }
`;

export const GET_STUDENTS_ASSIGNMENT_PROGRESS = gql`
  query GetStudentsAssignmentProgress(
    $input: GetStudentsAssignmentProgressInput!
  ) {
    getStudentsAssignmentProgress(input: $input) {
      studentId
      assignmentId
      progress
      student {
        id
        firstName
        lastName
        emeji
        email
        username
      }
    }
  }
`;

export const STUDENTS_ASSIGNMENT_PROGRESS_SUBSCRIPTION = gql`
  subscription StudentsAssignmentProgressSubscription(
    $input: StudentsAssignmentProgressSubscriptionInput!
  ) {
    studentsAssignmentProgressSubscription(input: $input) {
      studentId
      assignmentId
      progress
    }
  }
`;
